/* Diwali pack: countdown + festive window + wishes when an item is added to the cart.
   Settings: Theme settings > Diwali. Switches off by itself 4 days after the Diwali date. */
(function () {
  var cfgEl = document.getElementById('nv-dw-config');
  if (!cfgEl || window.__nvDw) return;
  window.__nvDw = true;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  // "YYYY-MM-DD HH:MM" in Indian time (UTC+5:30)
  function parse(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/.exec(String(s || '').trim());
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)) - 330 * 60000;
  }
  var target = parse(cfg.date);
  if (isNaN(target)) return;
  var END = target + 4 * 86400000;          // Diwali day + Govardhan Puja + Bhai Dooj
  function festive() { return Date.now() < END; }
  if (festive()) document.documentElement.classList.add('nv-dw-on');

  /* ---------- countdown sections ---------- */
  var boxes = [].slice.call(document.querySelectorAll('[data-nv-dw]'));
  var label;
  try { label = new Date(target).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Kolkata' }); } catch (e) { label = ''; }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    var now = Date.now(), left = target - now;
    boxes.forEach(function (b) {
      var d = b.querySelector('[data-nv-dw-date]'); if (d && label) d.textContent = label;
      if (now >= END) { b.hidden = true; return; }
      b.hidden = false;
      var live = left <= 0;
      b.classList.toggle('is-live', live);
      [].forEach.call(b.querySelectorAll('.nv-dw__t-before'), function (x) { x.hidden = live; });
      [].forEach.call(b.querySelectorAll('.nv-dw__t-live'), function (x) { x.hidden = !live; });
      if (live) return;
      var s = Math.floor(left / 1000);
      var days = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      var set = function (sel, v) { var e = b.querySelector(sel); if (e) e.textContent = v; };
      set('[data-nv-dw-d]', pad(days)); set('[data-nv-dw-h]', pad(h)); set('[data-nv-dw-m]', pad(m)); set('[data-nv-dw-s]', pad(sec));
    });
  }
  function startTimer() {
    boxes = [].slice.call(document.querySelectorAll('[data-nv-dw]'));
    if (!boxes.length) return;
    tick(); setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startTimer); else startTimer();

  /* ---------- wishes when an item is added to the cart ---------- */
  if (!cfg.wishes || !festive()) return;
  var WISHES = [
    'May the festival of lights fill your home with joy, peace and prosperity.',
    'May Goddess Lakshmi bless you and your family with health, wealth and happiness.',
    'May every diya you light bring brightness and good fortune into your life.',
    'Wishing you a Diwali full of light, love and divine blessings.',
    'May this Diwali bring new hope, positivity and endless good luck to your home.',
    'Shubh Deepavali! May your life shine as bright as the diyas of Diwali.'
  ];
  var idx = Math.floor(Math.random() * WISHES.length), last = 0, hideT = null, el = null;

  function build() {
    el = document.createElement('div');
    el.className = 'nv-dw-wish'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
    var sparks = '';
    for (var i = 0; i < 14; i++) {
      var a = (i / 14) * Math.PI * 2, r = 40 + (i % 3) * 22;
      sparks += '<i class="nv-dw-spark" style="--x:' + Math.round(Math.cos(a) * r) + 'px;--y:' + Math.round(Math.sin(a) * r) + 'px;animation-delay:' + (i % 4) * 60 + 'ms"></i>';
    }
    el.innerHTML = sparks +
      '<span class="nv-dw-wish__diya" aria-hidden="true">\uD83E\uDE94</span>' +
      '<div class="nv-dw-wish__t"><p class="nv-dw-wish__h">Happy Diwali!</p><p class="nv-dw-wish__p"></p><p class="nv-dw-wish__s"></p></div>' +
      '<span class="nv-dw-wish__bar" aria-hidden="true"></span>';
    el.addEventListener('click', hide);
    document.body.appendChild(el);
  }
  function hide() { if (el) el.classList.remove('is-in'); clearTimeout(hideT); }
  function wish() {
    var now = Date.now();
    if (now - last < 2500) return;               // one popup per burst of adds
    last = now;
    if (!el) build();
    idx = (idx + 1) % WISHES.length;
    el.querySelector('.nv-dw-wish__p').textContent = WISHES[idx];
    el.querySelector('.nv-dw-wish__s').textContent = 'Added to your cart \u00b7 ' + (cfg.sign || '');
    el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');   // restart the animation
    clearTimeout(hideT); hideT = setTimeout(hide, 5000);
  }

  var theirFetch = window.fetch;
  window.fetch = function (input, init) {
    var p = theirFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        var body = init && typeof init.body === 'string' ? init.body : '';
        if (body.indexOf('Free gift - prepaid') === -1) p.then(function (r) { if (r && r.ok) wish(); }, function () {});   // not for the automatic free gift
      }
    } catch (e) {}
    return p;
  };
})();
